<template>
	<div>

		<div class="container">
			<div class="logoBox">
				<div class="logoMark" style="padding: 10px;">
					<!--<div class="logoText">ATM</div>-->
					<img src="images/logo_atm.png" style="width: 100%;" />
				</div>
			</div>

			<div class="banner section">
				<div class="big"><span data-lang="t_22"></span><span
						style="color: aqua;">{{"#" + Number(userID).toString(16).toLocaleUpperCase()}}</span></div>
				<div class="big"><span data-lang="t_23"></span><span
						style="color: aqua;">{{"#" + Number(RefId).toString(16).toLocaleUpperCase()}}</span></div>
				<div class="small">
					<span class="big" style="color: azure;">{{userTitle}}：</span>
					<span style="color: #F00;font-size: 1.2rem;">{{userType}}</span><br>
					
					<span class="big" style="color: #0F0;">{{CaoJieShang}}</span>
				</div>
			</div>

			<div class="card section">
				<div class="row" style="padding:14px">
					<div>
						<div class="title" data-lang="t_24"></div>
						<!--<div class="muted" ><div  @click="Announcement = 1" style="color: #FFF;font-size: 10;">ATM 2.0 公告区</div></div>
						-->
					</div>
				</div>
			</div>

			<div class="card section">
				<div class="row" style="padding:14px 14px 0">
					<div class="h2" data-lang="t_27"></div>
					<span class="pill" data-lang="t_28"></span>
				</div>
				<div class="list" style="padding:14px">
					<TeamTreeNode v-for="item in teamData" :key="item.id" :node="item" />
				</div>
			</div>
		</div>

		<!-- 公告弹窗 -->
		<div class="modalMask" :class="{show:Announcement > 0}">
			<div class="modal">
				<div class="modalHead">
					<div>公告</div>
					<div class="modalClose" @click="Announcement = 0">×</div>
				</div>
				<div class="modalBody">
					<div v-if="Announcement == 1" class="reward_container">
						<div class="reward_title">ATM 升级公告</div>
						
						<div class="reward_intro">
							经过一期运营，ATM取得了良好的效果，但是仍然有一些缺陷，所以进行制度大升级。
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">取消USDT补贴，改为ATM代币补贴</span>
								<span class="reward_desc">每位团队长需达成团队总业绩 60,000币（不含创世节点）</span>
							</div>
						
							
							<div class="reward_item">
								<span class="reward_level">VIP等级奖励机制（6月6日同步发放）</span>
								<span class="reward_desc">
									<span class="reward_highlight">玛莎拉蒂豪华轿车</span><br>
									<span class="reward_highlight">2%的加权分红</span><br>
								</span>
							</div>
						</div>
						
						<div class="reward_call">** 立即行动，锁定您的专属奖励！</div>
						
						
						<div class="reward_footer">
							<div>宣发单位：新加坡比特龙ATM基金会万事达集团</div>
							<div class="reward_date">（公告日期：2026年03月19日）</div>
						</div>
					</div>
					
				</div>
				<div class="modalFoot">
					<button class="btn" @click="Announcement = 0">关闭</button>
				</div>
			</div>
		</div>

		<!-- Bottom Nav -->
		<div class="bottom">
			<div class="bottom-inner">
				<div class="nav active">
					<i class="fas fa-home"></i>
					<span data-lang="t_2"></span>

				</div>
				<div class="nav" data-lang="t_3"></div>
				<div class="nav" data-lang="t_4"></div>
				<div class="nav" data-lang="t_5"></div>
			</div>
		</div>
	</div>


</template>

<script>
	import TeamTreeNode from './child/TeamTreeNode.vue'
	export default {
		name: 'Home',
		components: {
			TeamTreeNode
		},
		data() {
			return {
				userID: 0,
				RefId: 0,
				userTitle: "",
				userType: "",
				teamData: [],
				Announcement: 0, //公告
				CaoJieShang:"",
			}
		},
		mounted() {
			
			this.showUI();
		},
		methods: {
			setLanguage() {
				const elements = document.querySelectorAll('[data-lang]');

				elements.forEach(element => {
					const langValue = element.getAttribute('data-lang');

					element.innerHTML = Lang[lg][langValue];
				});
			},
			copyAddress(text){
				copyRefURL(text);
				
			},
			async showUI() {
				//判断是否是超级商
				
				
				if(IsShowAnnouncement == true){
					IsShowAnnouncement = false;
					//弹出某号公告
					//this.Announcement = 1//8//7;
				}
				this.setLanguage();
				const user = await conMine.getPeopleTree(Account).call();
				if(user.Type == 3)this.CaoJieShang = "尊贵的超级商";
				this.userID = user.id //Number(user.id).toString(16);
				this.RefId = user.fatherNode //Number(user.fatherNode).toString(16);
				
				if (user.Type == 1) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_3;
				} else if (user.Type == 2) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_33;
				} else if (user.Type == 3 || user.Type == 11) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_34;
				} else if (user.Type == 4 || user.Type == 12) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_35;
				}
				await Sleep(this.$waitTime);
				const child = await conMine.GetBrother(user.childNode, 100).call();

				if (child == null) return;
				const len = child.length;
				let point = 2;

				let index = 0;
				let team = [];
				while (point < len) {
					team[index] = {};
					team[index].id = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].people = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].totalMine = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].leval = Number("0x" + child.substring(point, point + 2));
					point += 2;
					team[index].quickenFloor = Number("0x" + child.substring(point, point + 2));
					point += 2;
					team[index].children = []; // 存储下级数据
					team[index].expanded = false; // 控制是否展开
					team[index].id = team[index].id.toString(16).toLocaleUpperCase(); //转换成16进制
					index++;
				}
				this.teamData = team;
			},
		},
	}
</script>
<style>
	.reward_container {

		color: #ffffff;
		font-family: 'Microsoft YaHei', 'Segoe UI', sans-serif;

		max-width: 800px;
		line-height: 1.7;

	}

	.reward_title {
		color: #00ffff;
		text-align: center;
		font-size: 1.5rem;
		margin-bottom: 6px;
		padding-bottom: 12px;
		border-bottom: 2px solid rgba(0, 255, 255, 0.3);
		text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
		letter-spacing: 2px;
	}

	.reward_intro {
		color: #cccccc;
		font-size: 0.8rem;
		margin-bottom: 25px;
		text-align: left;
		padding: 0 10px;
	}

	.reward_list {
		margin: 10px 0;
		padding-left: 0;
	}

	.reward_item {
		background: linear-gradient(90deg, rgba(0, 255, 255, 0.05), rgba(0, 255, 255, 0.02));
		border-left: 4px solid #00ffff;
		margin-bottom: 5px;
		padding: 6px 12px;
		border-radius: 0 8px 8px 0;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
		text-align: left;
	}

	.reward_item::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		height: 100%;
		width: 0;
		background: linear-gradient(90deg, rgba(0, 255, 255, 0.1), transparent);
		transition: width 0.5s ease;
		/* 【关键修复】让伪元素不响应鼠标事件，穿透点击到底层元素 */
		    pointer-events: none; 
		    z-index: 0; /* 确保它在内容之下 */
	}

	.reward_item:hover::before {
		width: 100%;
	}

	.reward_item:hover {
		transform: translateX(5px);
		box-shadow: 0 5px 15px rgba(0, 255, 255, 0.1);
	}

	.reward_level {
		color: #00ffff;
		font-weight: bold;
		font-size: 0.85rem;
		margin-bottom: 8px;
		display: block;
	}

	.reward_desc {
		color: #e0e0e0;
		font-size: 0.75rem;
		
	}

	.reward_highlight {
		color: #ffcc00;
		font-weight: bold;
		text-shadow: 0 0 5px rgba(255, 204, 0, 0.3);
	}

	.reward_call {
		text-align: center;
		font-size: 1.0rem;
		font-weight: bold;
		color: #00ffaa;
		margin: 6px 0;
		padding: 6px;
		background: rgba(0, 255, 170, 0.08);
		border-radius: 10px;
		border: 1px solid rgba(0, 255, 170, 0.2);
		animation: pulse 2s infinite;
	}

	@keyframes pulse {
		0% {
			box-shadow: 0 0 0 0 rgba(0, 255, 170, 0.4);
		}

		70% {
			box-shadow: 0 0 0 10px rgba(0, 255, 170, 0);
		}

		100% {
			box-shadow: 0 0 0 0 rgba(0, 255, 170, 0);
		}
	}

	.reward_contact {
		color: #aaaaaa;
		font-size: 0.7rem;
		text-align: center;
		margin: 6px 0;
		padding: 6px;
		background: rgba(255, 255, 255, 0.03);
		border-radius: 6px;
	}

	.reward_footer {
		font-size: 0.6rem;
		color: #888888;
		text-align: center;
		margin-top: 12px;
		padding-top: 6px;
		border-top: 1px solid #333333;
	}

	.reward_date {
		color: #999999;
		font-style: italic;
		margin-top: 5px;
	}
</style>